export const stats = {
  general: {
    filter: {
      group_by: {
        title: 'Группировать по',
        value: {
          // day: 'День',
          // week: 'Неделя',
          month: 'Месяц',
          country: 'Страна'
        }
      },

      status: {
        title: 'Статус'
      },

      country: {
        title: 'Страна'
      },

      number: {
        title: 'Номер'
      },

      all_period: {
        title: 'За весь период'
      }
    },

    cell: {
      fee: '0 списаний | {count} списание | {count} списания | {count} списаний'
    },

    field: {
      month: 'Месяц',
      country: 'Страна',
      number: 'Номер',
      number_count: 'Всего номеров в периоде',
      average_subscription_fee: 'Средняя абонентская плата за номер в периоде',
      connection_cost_sum: 'Оплачено за подключение номеров за период',
      subscription_fee_sum: 'Оплачено по абоненсткой плате за период',
      total: 'Итого'
    }
  },

  detailed: {
    field: {
      payment_sum: 'Оплачено за номер в период',
      current_status: 'Текущий статус',
      subscription_fee_count: 'Количество списаний по абонентской плате за период',
      last_payment_date: 'Дата последнего списания',
      total: 'Всего {count}'
    },
    tooltip: {
      sum: 'Сумма всех оплат по абонентской плате и за подключение номера.'
    }
  }
};
